import { NgModule } from '@angular/core';
import { MatListModule,
         MatSidenavModule,
         MatCardModule,
         MatTabsModule,
         MatBottomSheetModule,
         MatNativeDateModule,
         MatDatepickerModule,
         MatFormFieldModule,
} from '@angular/material';

const EXPORTED_MODULES: any[] =[
  MatSidenavModule,
  MatListModule,
  MatCardModule,
  MatTabsModule,
  MatBottomSheetModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatFormFieldModule
];

@NgModule({
    imports: EXPORTED_MODULES,
    exports: EXPORTED_MODULES
  })
  export class AngularMaterialBaseModule { }
